import { EY_GDS_EMPLOYER_ID } from "../../../constants";

export function shouldRestrictPastDates(employerId: string): boolean {
  if (!employerId) return false;

  const restrictedEmployers = [EY_GDS_EMPLOYER_ID];
  return restrictedEmployers.includes(employerId);
}

export const MIN_DATE_FOR_EY_GDS_EMPLOYER = new Date("2025-11-17")
  .toISOString()
  .split("T")[0];
